import { useEffect, useState } from 'react'

interface OSInfo {
  osName: string
  osVersion: string
}

interface BrowserInfo {
  browserName: string
  browserVersion: string
}

export function isFirefox() {
  return navigator.userAgent.toLowerCase().indexOf('firefox') > -1
}

export function getOSInfo(): OSInfo {
  const userAgent = navigator.userAgent
  let osName = 'Unknown'
  let osVersion = 'Unknown'

  // OS Detection
  if (userAgent.indexOf('Win') !== -1) {
    osName = 'Windows'
    const regex = /Windows NT (\d+\.\d+)/
    const matches = regex.exec(userAgent)
    if (matches) osVersion = matches[1]
  } else if (userAgent.indexOf('Mac') !== -1) {
    osName = 'macOS'
    const regex = /Mac OS X (\d+[._]\d+[._]\d+)/
    const matches = regex.exec(userAgent)
    if (matches) osVersion = matches[1].replace(/_/g, '.')
  } else if (userAgent.indexOf('Linux') !== -1) {
    osName = 'Linux'
  }

  return { osName, osVersion }
}

export function getBrowserInfo(): BrowserInfo {
  const userAgent = navigator.userAgent
  let browserName = 'Unknown'
  let browserVersion = 'Unknown'

  // Browser Detection
  if (userAgent.indexOf('Chrome') !== -1) {
    browserName = 'Chrome'
    const regex = /Chrome\/(\d+\.\d+)/
    const matches = regex.exec(userAgent)
    if (matches) browserVersion = matches[1]
  } else if (userAgent.indexOf('Firefox') !== -1) {
    browserName = 'Firefox'
    const regex = /Firefox\/(\d+\.\d+)/
    const matches = regex.exec(userAgent)
    if (matches) browserVersion = matches[1]
  } else if (userAgent.indexOf('Safari') !== -1) {
    browserName = 'Safari'
    const regex = /Version\/(\d+\.\d+)/
    const matches = regex.exec(userAgent)
    if (matches) browserVersion = matches[1]
  } else if (userAgent.indexOf('Edge') !== -1) {
    browserName = 'Edge'
    const regex = /Edge\/(\d+\.\d+)/
    const matches = regex.exec(userAgent)
    if (matches) browserVersion = matches[1]
  }

  return { browserName, browserVersion }
}

export function getSystemInfo(): string {
  const osInfo = getOSInfo()
  const browserInfo = getBrowserInfo()
  return `${browserInfo.browserName} ${browserInfo.browserVersion} on ${osInfo.osName} ${osInfo.osVersion}`
}

export function isInIframe() {
  return window.self !== window.top
}

export function useIsInIframe() {
  const [isInIframe, setIsInIframe] = useState(false)

  useEffect(() => {
    setIsInIframe(window.self !== window.top)
  }, [])

  return isInIframe
}
